import network from "./utils/network";
import pinia from "@/store/pinia";
import { useAuthSessionStore } from "@/store/pinia/useAuthSessionStore";
import PageLoading from "./components/module/loading/PageLoading";
import { EVENTS } from "./utils/eventBus";
import PortalOther from "@/views/Other.vue";
import { changeTheme, getCurrentTheme, localFetch, tenantIdFromPath } from "@/utils/util";
import { UI_THEMES } from "@/utils/const";
import { loadLanguageAsync } from "@/plugins/i18n";
import PortalError from "@/views/Error.vue";
import { defineAsyncComponent } from "vue";
import AppLayout from "@/layouts/AppLayout.vue";
import Toast from "primevue/toast";
export default {
  name: "PortalHome",
  methods: {
    getCurrentTheme
  },
  components: {
    AppLayout,
    PortalError,
    PortalOther,
    PageLoading,
    Toast,
    LoadingIndicator: defineAsyncComponent(() => import("@/components/module/loading/LoadingIndicator"))
  },
  computed: {
    tenantIdFromPath,
    UI_THEMES() {
      return UI_THEMES;
    },
    isLoginLayout() {
      return this.$route.meta ? this.$route.meta.loginLayout : false;
    },
    showSidebar() {
      return !this.$route.meta || !this.$route.meta.hideSidebar;
    }
  },
  async created() {
    this.tenantId = this.tenantIdFromPath;
    network.configure(this.$store, this.$router, this.$toast);
    const axios = network.createAxiosInstance();
    this.$store.commit("uiConfigStore/setCurrentTheme", localFetch("current_ui_theme"));
    changeTheme(localFetch("current_ui_theme"));

    // eventBus.$on(EVENTS.PAGE_LOADING, () => (this.pageLoaded = false));
    // eventBus.$on(EVENTS.PAGE_LOADED, () => (this.pageLoaded = true));

    await this.$store.dispatch("env/fetch");
    await useAuthSessionStore(pinia).bootstrap();
    let storedLocale = localFetch("stored_locale");
    if (storedLocale) {
      await loadLanguageAsync(storedLocale);
    } else {
      // default lang
      await loadLanguageAsync("hu");
    }
    if (this.tenantId) {
      this.validTenant = true;
      document.querySelector('link[rel="icon"]').setAttribute("href", process.env.VUE_APP_FAVICON);
      this.tenantExamined = true;
    } else {
      this.tenantExamined = true;
    }
  },
  data() {
    return {
      EVENTS,
      pageLoaded: true,
      tenantId: null,
      tenantExamined: false,
      validTenant: false,
      onboardingPage: false
    };
  }
};